import React, { useCallback, useEffect, useState } from 'react';
import { getLoanerUnits, setLoanerUnit, errorMessage } from '../../services/contracts/contractsService';
import { formatDate } from './contractLabels';

// Marca un sensor como unidad de préstamo (inventario que los vendedores pueden prestar).
// Se guarda al instante, aparte del formulario del sensor.
const LoanerToggle = ({ sensorId }) => {
    const [unit, setUnit] = useState(null);
    const [loaded, setLoaded] = useState(false);
    const [busy, setBusy] = useState(false);

    const load = useCallback(async () => {
        try {
            const units = await getLoanerUnits();
            setUnit(units.find((u) => u.sensorId === sensorId) || null);
        } catch (e) {
            console.error('Error al consultar las unidades de préstamo: ', e);
        } finally {
            setLoaded(true);
        }
    }, [sensorId]);

    useEffect(() => { load(); }, [load]);

    const toggle = async () => {
        setBusy(true);
        try {
            await setLoanerUnit(sensorId, !unit);
            await load();
        } catch (e) {
            alert(errorMessage(e));
        } finally {
            setBusy(false);
        }
    };

    if (!loaded) return null;

    return (
        <div className="w-full max-w-5xl mx-auto mb-4 p-3 rounded border border-gray-200 bg-gray-50 flex flex-wrap items-center gap-x-4 gap-y-1">
            <label className="flex items-center gap-2 font-semibold text-black cursor-pointer">
                <input type="checkbox" checked={!!unit} disabled={busy} onChange={toggle}
                    className="h-5 w-5 text-blue-600 cursor-pointer" />
                Unidad de préstamo
            </label>
            <span className="text-sm text-gray-600">
                {!unit && 'Al marcarla, los vendedores podrán prestarla a prospectos.'}
                {unit && unit.assignedToClient && (
                    <span className="text-red-700 font-semibold">
                        Está asignado a {unit.clients.length ? unit.clients.join(', ') : 'un cliente'}: no se puede prestar.
                        Desmárcalo o termina esos contratos.
                    </span>
                )}
                {unit && unit.available && 'Disponible para préstamo.'}
                {unit && !unit.available && (
                    <>Prestada{unit.prospectName || unit.prospectEmail ? ` a ${unit.prospectName || unit.prospectEmail}` : ''}
                        {' '}hasta {formatDate(unit.validUntil)} (vendedor: {unit.sellerEmail || '-'}).</>
                )}
            </span>
        </div>
    );
};

export default LoanerToggle;
